export default "__VITE_ASSET__D8vTV571__"